module.exports = __webpack_public_path__ + "img/za.26d8c015.svg";